import React, { useState } from 'react';
import '../css/Project.css';
import '../css/Main.css';
import strykCover from '../assets/stryk-cover.webp';
import buxCover from '../assets/bux-cover.webp';
import wonderkindCover from '../assets/wonderkind-cover.webp';

import ButtonLarge from '../components/Button-large';
import '../css/Buttons.css';
import Project from '../components/Projects';
import ProjectStryk from './ProjectStryk'
import ProjectBuxZero from './ProjectBuxZero'
import ProjectWonderkind from './ProjectWonderkind'

import { Shape1, ShapeRectangle, Shape3 } from '../components/Shapes';
import { MdArrowForward, MdBuild, MdNavigation, MdPersonAddDisabled, MdChat, MdLocalCafe, MdViewQuilt,MdImageSearch, MdFlashOn, MdTextFields } from 'react-icons/md';



const Work = ({ }) => {

  const [isProjectVisible, setIsProjectVisible] = useState(false);


  const handleButtonClick = () => {
    setIsProjectVisible(!isProjectVisible); // Toggle visibility
  };
  

  return (
    <div className="homepage">

      {/* Hero Section */}

      <header className="intro">

        <div className='shapes-container-inside blur-desktop blur-mobile'>

          <ShapeRectangle className="shape shape-5" />
          <Shape3 className="shape shape-6" />
        </div>
        

        <div className="hero">
          <h1>Take your digital product to the next level</h1>
          <p>I help teams create and improve the tools people rely on — from apps and dashboards to participant platforms. I specialize in design systems, user experience and interface (UX/UI), visual design, and UX copywriting.</p>
          <ButtonLarge
            className="button-large"
            label="Start today"
            to="/Contact"
            setIsButtonHovered={() => {}}
            variant='outlined'
            icon={() => <MdArrowForward className="animated-icon" />} // Animated icon
          />
        </div>
      </header>
      <div className='shapes-container-outside hide-mobile'>
        <Shape1 className="shape shape-1" />
        <ShapeRectangle className="shape shape-2" />
        <Shape3 className="shape shape-3" />
        <Shape1 className="shape shape-4" />
      </div>

      {/* End of Hero Section */}

      {/*Challenges section*/}

      <section className="challenges">

        <div className="section-header">
          <h2>Your challenges</h2>
        </div>

        <div className="challenges-grid">
          <div className="challenge-col">
            <div className="challenge-icon">
              <MdBuild size={48} />
            </div>
            <h3>Inconsistent<br />design?</h3>
            <p>
              Is your product lacking a cohesive look and feel, making it harder to maintain or scale?
            </p>
          </div>
          <div className="challenge-col">
            <div className="challenge-icon">
              <MdNavigation size={48} />
            </div>
            <h3>Hard to<br />navigate?</h3>
            <p>
              Do users struggle to find what they need because of unclear structure or navigation?
            </p>
          </div>
          <div className="challenge-col">
            <div className="challenge-icon">
              <MdPersonAddDisabled size={48} />
            </div>
            <h3>Poor<br />onboarding?</h3>
            <p>
              Are users abandoning your product early because of a confusing onboarding process?
            </p>
          </div>
          <div className="challenge-col">
            <div className="challenge-icon">
              <MdChat size={48} />
            </div>
            <h3>Confusing<br />copy?</h3>
            <p>
              Are unclear instructions or technical jargon causing frustration and driving users away?
            </p>
          </div>
        </div>

        <div className='challenges-button'>
        <ButtonLarge
          className="button-large"
          label="Let's solve them"
          to="/Contact"
          setIsButtonHovered={() => {}}
          variant='filled'
          icon={() => <MdArrowForward className="animated-icon" />} // Animated icon
        />
        </div>

      </section>

      {/* End of Challenges section*/}

      {/*Solutions section*/}

      <section className="solutions">

        <div className="solutions-grid">

          <div className="section-header">
            <h2>My solutions</h2>
          </div>

          <div className="solutions-row-left">
            <div className="solutions-icon">
              <MdViewQuilt size={48} />
            </div>
            <div className='solutions-content'>
              <h3>Design systems</h3>
              <p>
                I create scalable design systems and component libraries that bring consistency, efficiency, and clarity to your product.
              </p>
            </div>
          </div>

          <div className="solutions-row-right">
            <div className="solutions-icon">
              <MdImageSearch size={48} />
            </div>
            <div className='solutions-content'>
              <h3>Usability audit</h3>
              <p>
                I uncover friction points, giving you clear, evidence-based recommendations to improve adoption.
              </p>
            </div>
          </div>

          <div className="solutions-row-left">
            <div className="solutions-icon">
              <MdFlashOn size={48} />
            </div>
            <div className='solutions-content'>
              <h3>Quick prototyping</h3>
              <p>
                I test your ideas early, validate with users, and reduce development risk.
              </p>
            </div>
          </div>

          <div className="solutions-row-right">
            <div className="solutions-icon">
              <MdImageSearch size={48} />
            </div>
            <div className='solutions-content'>
              <h3>Tailored UX copy</h3>
              <p>
                I write tailored UX copy that guides users clearly, reduces friction, and boosts engagement.
              </p>
            </div>
          </div>
          <div className="solutions-button">
            <ButtonLarge
              className="button-large"
              label="Let's have a coffee"
              to="/Contact"
              setIsButtonHovered={() => {}}
              variant='outlined'
              icon={MdLocalCafe} // Animated icon
            />
          </div>
        </div>
      </section>

      {/* End of Solutions section*/}

      {/* Case studies Section */}

      <section className="case-studies">

        <div className="case-studies-grid">

          <div className="section-header">
            <h2>Case studies</h2>
          </div>

          <div className='cases'>
            <Project
              chipLabelA="DESIGN SYSTEM"
              chipLabelB="NAVIGATION"
              chipLabelC="REDESIGN"
              image={buxCover}
              title='BUX Zero'
              description="I optimized BUX Zero’s onboarding, reducing drop-off and launching a seamless cross-platform flow that boosted successful account creation rates."
              buttonLabel="View case study"
              to="/ProjectBuxZero"
              
            />
            <Project
              chipLabelA="prototyping"
              chipLabelB="NAVIGATION"
              chipLabelC="accessibility"
              image={wonderkindCover}
              title='Wonderkind'
              description="I redesigned Wonderkind’s job advertising platform with a scalable design system, improved navigation, and validated features through testing."
              buttonLabel="View case study"
              to="/ProjectWonderkind"
            />
            <Project
              chipLabelA="DESIGN SYSTEM"
              chipLabelB="onboarding"
              chipLabelC="REDESIGN"
              image={strykCover}
              title='Stryk'
              description="I redesigned BUX’s Stryk app with a new brand identity, accessible color system, and refined component library to accelerate feature delivery."
              buttonLabel="View case study"
              to="/ProjectStryk"
            />
          </div>

          <div className='projects-list'>

          </div>

        </div>

        {isProjectVisible && (
          <div className="project-popup">
          </div>
        )}
      </section>

    </div>
  );
};

export default Work;
